import { createStore } from 'vuex'
import { find } from 'underscore'
import axios from 'axios'

export default createStore({

  state () {
    return {
      nid: typeof window.product !== 'undefined' ? window.product.nid : undefined,
      typeId: typeof window.product !== 'undefined' ? window.product.typeId : undefined,
      price: typeof window.product !== 'undefined' ? window.product.price : undefined,
      price_action: typeof window.product !== 'undefined' ? window.product.price_action : undefined,
      price_print6: typeof window.product !== 'undefined' ? window.product.price_print6 : undefined,
      price_print6_action: typeof window.product !== 'undefined' ? window.product.price_print6_action : undefined,
      price_print12: typeof window.product !== 'undefined' ? window.product.price_print12 : undefined,
      price_print12_action: typeof window.product !== 'undefined' ? window.product.price_print12_action : undefined,
      price_jj6: typeof window.product !== 'undefined' ? window.product.price_jj6 : undefined,
      price_jj6_action: typeof window.product !== 'undefined' ? window.product.price_jj6_action : undefined,
      price_jj12: typeof window.product !== 'undefined' ? window.product.price_jj12 : undefined,
      price_jj12_action: typeof window.product !== 'undefined' ? window.product.price_jj12_action : undefined,
      price_union6: typeof window.product !== 'undefined' ? window.product.price_union6 : undefined,
      price_union6_action: typeof window.product !== 'undefined' ? window.product.price_union6_action : undefined,
      price_union12: typeof window.product !== 'undefined' ? window.product.price_union12 : undefined,
      price_union12_action: typeof window.product !== 'undefined' ? window.product.price_union12_action : undefined,
      price_lite6: typeof window.product !== 'undefined' ? window.product.price_lite6 : undefined,
      price_lite6_action: typeof window.product !== 'undefined' ? window.product.price_lite6_action : undefined,
      price_lite12: typeof window.product !== 'undefined' ? window.product.price_lite12 : undefined,
      price_lite12_action: typeof window.product !== 'undefined' ? window.product.price_lite12_action : undefined,
      price_start6: typeof window.product !== 'undefined' ? window.product.price_start6 : undefined,
      price_start6_action: typeof window.product !== 'undefined' ? window.product.price_start6_action : undefined,
      price_start12: typeof window.product !== 'undefined' ? window.product.price_start12 : undefined,
      price_start12_action: typeof window.product !== 'undefined' ? window.product.price_start12_action : undefined,
      price_max6: typeof window.product !== 'undefined' ? window.product.price_max6 : undefined,
      price_max6_action: typeof window.product !== 'undefined' ? window.product.price_max6_action : undefined,
      price_max12: typeof window.product !== 'undefined' ? window.product.price_max12 : undefined,
      price_max12_action: typeof window.product !== 'undefined' ? window.product.price_max12_action : undefined,
      demo: typeof window.product !== 'undefined' ? window.product.demo : undefined,
      current_date: typeof window.product !== 'undefined' ? window.product.current_date : undefined,
      date_action_start: typeof window.product !== 'undefined' ? window.product.date_action_start : undefined,
      date_action_end: typeof window.product !== 'undefined' ? window.product.date_action_end : undefined,

      date_payment1: typeof window.product !== 'undefined' ? window.product.date_payment1 : undefined,
      price_payment1: typeof window.product !== 'undefined' ? window.product.price_payment1 : undefined,
      date_payment2: typeof window.product !== 'undefined' ? window.product.date_payment2 : undefined,
      price_payment2: typeof window.product !== 'undefined' ? window.product.price_payment2 : undefined,
      date_payment3: typeof window.product !== 'undefined' ? window.product.date_payment3 : undefined,
      price_payment3: typeof window.product !== 'undefined' ? window.product.price_payment3 : undefined,
      price_materials: typeof window.product !== 'undefined' ? window.product.price_materials : undefined,
      price_video: typeof window.product !== 'undefined' ? window.product.price_video : undefined,
      price1: typeof window.product !== 'undefined' ? window.product.price1 : undefined,
      price2: typeof window.product !== 'undefined' ? window.product.price2 : undefined,
      price3: typeof window.product !== 'undefined' ? window.product.price3 : undefined,
      price1_action: typeof window.product !== 'undefined' ? window.product.price1_action : undefined,
      price2_action: typeof window.product !== 'undefined' ? window.product.price2_action : undefined,
      price3_action: typeof window.product !== 'undefined' ? window.product.price3_action : undefined,
      label_price1: typeof window.product !== 'undefined' ? window.product.label_price1 : undefined,
      label_price2: typeof window.product !== 'undefined' ? window.product.label_price2 : undefined,
      label_price3: typeof window.product !== 'undefined' ? window.product.label_price3 : undefined,
      city: typeof window.product !== 'undefined' ? window.product.city : undefined,
      date: typeof window.product !== 'undefined' ? window.product.date : undefined,
      date_full: typeof window.product !== 'undefined' ? window.product.date_full : undefined,
      image: typeof window.product !== 'undefined' ? window.product.image : undefined,
      imageAlt: typeof window.product !== 'undefined' ? window.product.imageAlt : undefined,
      imageTitle: typeof window.product !== 'undefined' ? window.product.imageTitle : undefined,

      basketItems: [],
      fullItems: [],

      catalogTitle: typeof window.catalogTitle !== 'undefined' ? window.catalogTitle : undefined,
      items: typeof window.items !== 'undefined' ? window.items : undefined,
      studyItems: typeof window.studyItems !== 'undefined' ? window.studyItems : undefined,
      currentTrends: typeof window.selectedTrends !== 'undefined' ? window.selectedTrends : undefined,
      trends: typeof window.trends !== 'undefined' ? window.trends : undefined,
      currentType: typeof window.type !== 'undefined' ? window.type : undefined,
      types: typeof window.types !== 'undefined' ? window.types : undefined,
      url: '/' + window.location.href.split('/').slice(-1).pop(),
      studyUrl: '/' + window.location.href.split('/').slice(-1).pop(),
      front_page: typeof window.front_page !== 'undefined' ? window.front_page : undefined,
      type_page: typeof window.type !== 'undefined' ? window.type !== "0" : undefined,

      text: {
        m: window.Drupal.t('м.'),
        register: window.Drupal.t('Зареєструватися'),
        from: window.Drupal.t('від'),
        all_trends: window.Drupal.t('Всі напрями'),
        all_types: window.Drupal.t('Всі типи'),
        show_more: window.Drupal.t('Показати ще'),
        buy_materials: window.Drupal.t('Купити матеріали'),
        buy_video: window.Drupal.t('Придбати відео'),
        price_one_person_pay_before: window.Drupal.t('Вартість участі однієї особи при оплаті до'),
        price_one_person: window.Drupal.t('Вартість участі однієї особи'),
        price_materials: window.Drupal.t('Вартість матеріалів'),
        price_video: window.Drupal.t('Вартість відео'),
        months: window.Drupal.t('місяців'),
        printed_magazine: window.Drupal.t('Друкований журнал'),
        living_magazine: window.Drupal.t('Живий журнал'),
        printed_and_live_magazines: window.Drupal.t('Друкований та живий журнали'),
        price_one_copy: window.Drupal.t('Ціна одного примірника'),
        buy: window.Drupal.t('Придбати'),
        demo_text: window.Drupal.t('Ви можете безкоштовно оцінити всі переваги сервісу'),
      },

      langcode: typeof window.langcode !== 'undefined' ? window.langcode : 'uk',

    }
  },

  mutations: {

    updateBasketItems(state, items) {
      state.basketItems = items
    },

    updateFullItems(state, items) {
      state.fullItems = items
    },

    resetTrends (state) {
      state.currentTrends = []
    },

    resetBasketItems (state) {
      state.fullItems = []
      state.basketItems = []
    },

    resetType (state) {
      state.currentType = 0
    },

    updateTrends (state, key) {
      let index = state.currentTrends.indexOf(key.toString())
      if ( index !== -1 ) {
          state.currentTrends.splice(index, 1)
      } else {
        state.currentTrends.push(key.toString())
      }
    },

    updateItems (state, items) {
      state.items = items
    },

    updateStudyItems (state, items) {
      state.studyItems = items
    },

    setUrl (state, url) {
      state.url = url
    },

    setStudyUrl (state, url) {
      state.studyUrl = url
    },

    selectType (state, type) {
      state.currentType = type
    },

    appendItems (state, items) {
      state.items = state.items.concat(items)
    },

    appendStudyItems (state, items) {
      state.studyItems = state.studyItems.concat(items)
    }

  },

  getters: {

    getTrendsQuery(state) {
      var trendsQuery = '';
      switch ( state.currentTrends.length ) {
        case 0:
          trendsQuery = ''
        break
        case 1:
          trendsQuery = '?trend=' + state.currentTrends[0]
        break
        default:
          trendsQuery = '?' + state.currentTrends.map((x) => ( 'trend[]=' + x) ).join('&')
        break
      }
      return trendsQuery;
    },

    getTypeUrl(state, getters) {
      let type = find(state.types, function(t){ return t.id == state.currentType })
      return typeof type !== 'undefined' ? type.path : getters.getBaseCatalogUrl
    },

    getSelectedType(state) {
      let type = find(state.types, function(t){ return t.id == state.currentType })
      return typeof type !== 'undefined' ? type.id : 0
    },

    getBaseCatalogUrl(state) {
      return '/' + (state.langcode == 'uk' ? '' : state.langcode.concat('/')) + 'catalog'
    },

    getBaseStudyUrl(state) {
      return '/' + (state.langcode == 'uk' ? '' : state.langcode.concat('/')) + 'navchannya'
    }

  },

  actions: {

    resetBasketItems (context) {
      context.commit('resetBasketItems')
      return new Promise((resolve, reject) => {
        axios.post('/basket/reset',
        {},
        {
          emulateJSON: true,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          }
        }
        ).then((response) => {
          resolve(response)
        }, error => {
          reject(error)
        })
      })
    },

    resetTrends (context) {
      context.commit('resetTrends')
    },

    resetType (context) {
      context.commit('resetType')
    },

  }
})
